<template>
    <div>
        <v-container>
        <v-row>
            <v-col  cols="12" >
                <v-card class="mx-auto my-12" max-width="1000">
                    <v-responsive :aspect-ratio="16/9">
                    <v-card-title class="text-x1">
                        <span v-show="show">
                            {{ data1.title }}
                        </span>
                        <v-spacer></v-spacer>
                    </v-card-title>

                    <v-card-text>
                        <v-row
                            align="center"
                            class="mx-0 mar-t-15"
                            v-show="show"
                        >
                            <div class="text-x2">
                                {{
                                    data1.created_name +
                                        " - " +
                                        data1.created_date
                                }}
                            </div>
                        </v-row>

                        <div class="my-4 text-x3" v-show="show">
                            <v-card-text
                                class="subtitle-3"
                                v-html="data1.content"
                            ></v-card-text>
                        </div>

                        <!-- <div>
                            Small plates, salads & sandwiches - an intimate
                            setting with 12 indoor seats plus patio seating.
                        </div> -->
                    </v-card-text>

                    <v-divider
                        class="mx-4 mar-t-x"
                        v-if="show == true"
                    ></v-divider>

                    <v-card-title :class="show2 == true ? 'mar-t-40' : ''">
                        <v-row>
                            <v-col cols="12" md="6">
                                <span class="timex">{{ timestamp }}</span>
                                <br />
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="12" md="4" class="mat-t-15 text-cene">
                                <v-text-field
                                    :disabled="show2 == true"
                                    v-model="staff.emp_id"
                                    @input="checkstaff(staff.emp_id)"
                                    style="font-size:25px;"
                                    outlined
                                    label="Employee ID"
                                    maxlength="7"
                                    :rules="empR"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" class="mar-t-40">
                                <span class="text-x4"
                                    >การลงเวลา เข้า และ ออก และห้ามลงเวลาแทนกัน
                                    เป็นกฏกติกาของบริษัทฯ
                                    พนักงานทุกคนต้องปฏิบัติตาม หากลงเวลาไม่ครบ
                                    พนักงานจะต้องอธิบายและชี้แจงให้กับหัวหน้าส่วนงาน
                                    และแผนก HR รับทราบไม่เกิน 1 วันทำการ
                                    หากคำชี้แจงไม่สมเหตุสมผล
                                    จะพิจารณาตามกฏระเบียบเรื่อง วินัยและโทษต่อไป
                                </span>
                            </v-col>
                        </v-row>
                    </v-card-title>

                    <v-card-text v-show="show2" class="mar-t-20 " >
                        <v-chip-group
                            active-class="deep-purple accent-4 white--text"
                            column
                        >
                            <v-row>
                                <v-col cols="12" md="6">
                                    <video
                                        v-if="isMobile == false"
                                        ref="camerapc"
                                        :width="400"
                                        autoplay
                                        playsinline
                                    ></video>
                                    <video
                                        v-if="isMobile == true"
                                        style="margin-left: -28px"
                                        ref="cameramoblie"
                                        :width="365"
                                        :height="200"
                                        autoplay
                                        playsinline
                                    ></video>
                                    <br />
                                    <span class="text-x44"
                                        >กรุณาถ่ายรูปหน้าตรง เห็นใบหน้าชัดเจน
                                        และแต่งกายสุภาพ
                                    </span>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <p class="text-x11">
                                        Location :
                                        {{ distance_used.branch_name }}
                                    </p>
                                    <p class="text-x11x">
                                        {{ data.emp_id }} <br />{{
                                            data.emp_name
                                        }}
                                    </p>

                                    <v-row dense>
                                        <v-col
                                            cols="12"
                                            v-if="data.att_type != 'IN'"
                                        >
                                            <v-card color="blue-grey darken-4 etx">
                                                <div
                                                    class="d-flex flex-no-wrap justify-space-between"
                                                >
                                                    <div>
                                                        <v-card-title
                                                            class="text-x111"
                                                            >TIME IN
                                                            {{
                                                                data.in_time
                                                            }}</v-card-title
                                                        >

                                                        <v-card-subtitle
                                                            class="text-x1111"
                                                            >{{
                                                                data.in_remark
                                                            }}</v-card-subtitle
                                                        >
                                                    </div>

                                                    <v-avatar
                                                        class="ma-3"
                                                        size="100"
                                                        tile
                                                    >
                                                        <v-img
                                                            :src="
                                                                url_pic +
                                                                    data.in_img
                                                            "
                                                        ></v-img>
                                                    </v-avatar>
                                                </div>
                                            </v-card>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            v-if="data.att_type == 'DONE'"
                                        >
                                            <v-card color="blue-grey darken-4">
                                                <div
                                                    class="d-flex flex-no-wrap justify-space-between"
                                                >
                                                    <div>
                                                        <v-card-title
                                                            class="text-x111"
                                                            >TIME OUT
                                                            {{
                                                                data.out_time
                                                            }}</v-card-title
                                                        >

                                                        <v-card-subtitle
                                                            class="text-x1111"
                                                            >{{
                                                                data.out_remark
                                                            }}</v-card-subtitle
                                                        >
                                                    </div>
                                                    <!-- class="fix-img-ava" -->
                                                    <v-avatar
                                                        class="ma-3"
                                                        size="100"
                                                        tile
                                                    >
                                                        <v-img
                                                            :src="
                                                                url_pic +
                                                                    data.out_img
                                                            "
                                                        ></v-img>
                                                    </v-avatar>
                                                </div>
                                            </v-card>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            class="mt-3"
                                            v-if="data.att_type != 'DONE'"
                                        >
                                            <v-text-field
                                                v-model="staff.remark"
                                                outlined
                                                :label="
                                                    data.need_remark == 'Y'
                                                        ? '**กรุณากรอกสาเหตุที่ลงเวลาผ่านมือถือ'
                                                        : 'หมายเหตุ (ถ้ามี)'
                                                "
                                            ></v-text-field>

                                            <v-btn
                                                :disabled="
                                                    data.need_remark == 'Y' &&
                                                        staff.remark == ''
                                                "
                                                @click="stamptime"
                                                dense
                                                color="green accent-3 white-text"
                                                block
                                                class="mar-t-20"
                                            >
                                                {{
                                                    data.att_type == "IN"
                                                        ? "ลงเวลาเข้างาน"
                                                        : "ลงเวลาออกงาน"
                                                }}
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-chip-group>
                    </v-card-text>
                </v-responsive>
                </v-card>
            </v-col>
        </v-row>
   </v-container>
        <canvas
            style="display: none"
            id="photoTaken"
            ref="canvas"
            :width="450"
            :height="337.5"
        ></canvas>
    </div>
</template>
<script>
import { WebCam } from "vue-cam-vision"
import ViewAnnounceHr from "./ViewAnnounceHr"
// import Viewannouce from "../pages/Project/components/ViewAnnounce"
import axios from "axios"

export default {
  
    components: {
        "view-annouce-hr": ViewAnnounceHr,
        WebCam,
    },
    async beforeMount() {
       
        //     (await navigator.userAgent.indexOf("Windows")) != -1 ||
        //     (await navigator.userAgent.indexOf("Mac")) != -1
        //         ? "pc"
        //         : "mobile"
        await this.get_lan_lng()
        await this.createCameraElement()
        // await this.setsize()

        let device
        device = await navigator.userAgent.toLowerCase()
       
        const ismatch  = /(iphone|ipad|ipod|tablet|(android(?!.*mobile)))/.test(device);
        if(ismatch){
            this.isMobile = true
            // console.log('is mobile devices')
            this.device = 'mobile'
            this.staff.device = 'mobile'
        }else{
            this.isMobile = false
            // console.log('is pc devices ')
            this.device = 'pc'
            this.staff.device = 'pc'
        }
        let usage = device.split(" ",10)
        // alert(window.navigator.userAgent);
        // console.log('split : ',usage[1])
        // let str
        // str = usage[2]
        // str.substring()
	// alert("Mobile Device");
    },
    beforeDestroy() {
        if (typeof window === "undefined") return

        window.removeEventListener("resize", this.onResize, { passive: true })
    },
    
    mounted() {
        this.getAjax1()
        this.chk_active_camera()
        // this.onResize()
        // this.setsize()
        window.addEventListener("resize", this.onResize, { passive: true })
        // if (localStorage.token != undefined) {
        //     console.log(this.$route.query.q)
        //     // this.get_emp_id()
        //     this.checkstaff(this.$route.query.q)
        // }
        // console.log(this.emp_id, "--x")
        if (this.$route.query.q != undefined && this.$route.query.q != "") {
            this.staff.emp_id = this.$route.query.q
            this.checkstaff(this.staff.emp_id)
            //
        }
    },
    data() {
        return {
            emp_id: this.$route.query.q,
            data1: [],
            howpic1: `${process.env.VUE_APP_ROOT_API}/api/announce/attachments/`,
            image: {
                images: [],
            },
            isMobile: false,
            device: "",
            staff: {
                emp_id: "",
                remark: "",
                img: "",
                lat: "",
                lng: "",
                ip: "",
                device: "",
                branch_id: "",
                km: "",
            },
            captures: [],
            member: {
                name: localStorage.fullname,
                team: localStorage.team_name,
                img: localStorage.emp_img,
            },
            timestamp: "",
            url_pic: `${process.env.VUE_APP_ROOT_API}/api/time-att/image/`,
            gps: {
                lat: "",
                lng: "",
            },
            branch: [],
            data: [],
            img: null,
            branch_new: [],
            distance_cal: [],
            distance_used: {},
            empR: [(v) => v.length <= 7 || "Max 7 characters"],
            empR2: [(v) => v.length <= 7 || "Max 7 characters"],

            show: true,
            show2: false,
            tk: { headers: { Authorization: "Bearer " + localStorage.token } },
            size_screen:{
                x:0,
                y:0
            },
            active_on:"",
        }
    },
    created() {
        setInterval(this.getNow, 1000)
    },
    methods: {
        // async get_emp_id() {
        //     await axios
        //         .get(
        //             `${process.env.VUE_APP_ROOT_API}/api/account-detail`,
        //             this.tk
        //         )
        //         .then((response) => {
        //             this.staff.emp_id = response.data.emp_id
        //             this.checkstaff(this.staff.emp_id)
        //         })
        // },
        async getAjax1() {
            const urlx = `${process.env.VUE_APP_ROOT_API}/api/announce-active`

            await axios
                .get(urlx)
                .then((response) => {
                    response.data.map((each) => {
                        var ob = [...each.images]
                        this.image.images = []
                        ob.map((src) => {
                            this.image.images.push(
                                this.showpic1 +
                                    src.file_store_name +
                                    "/" +
                                    src.file_name
                            )
                        })
                        this.data1.push(Object.assign({}, each, this.image))
                        this.data1 = this.data1[0]
                    })
                })
                .catch((error) => {
                    console.log(error)
                    return false
                })
        },

        onResize() {
            // if(this.isMobile <= 950){
            //     this.isMobile = windows.screen.width < 950
            // }


            // if(this.device = 'mobile'){
                
            //     this.isMobile = window.screen.width <= 950
            //     console.log('on resize 950',this.isMobile)
            //     console.log(navigator.userAgent)
            // }else{
            //     console.log("landscape screen")
            //     if(window.screen.width <= 950){
            //         const userAgent = navigator.userAgent.toLowerCase();
            //         const isTablet = /(iphone|ipad|tablet|(android(?!.*mobile)))/.test(userAgent);
            //         // sessionStorage.setItem('ismb','mobile')
            //         // console.log('else mobile 950',isTablet)
                  
            //         console.log('else mobile',this.isMobile)
            //     }else if(window.screen.width > 950 && window.screen.width < 1200){
            //         const userAgent = navigator.userAgent.toLowerCase();
            //         const isTablet = /(iphone|ipad|tablet|(android(?!.*mobile)))/.test(userAgent);
            //         // sessionStorage.setItem('ismb','mobile')
                
            //         console.log('tablet 950-1200',this.isMobile)
            //         // this.isMobile = window.screen.width < 950
            //     }else{
            //         const userAgent = navigator.userAgent.toLowerCase();
            //         const isTablet = /(iphone|ipad|tablet|(android(?!.*mobile)))/.test(userAgent);
            
            //         console.log('else  pc')
            //         console.log('is pc : ',isTablet)
            //         // this.isMobile = window.screen.width < 1080
            //     }
            
                // }


            //     if(window.screen.width <= 950){
            //        console.log('if 1')
            //        sessionStorage.setItem('issb','tablet')
            //         this.isMobile = true
            //         // this.isMobile = window.screen.width < 950
            //     }else if(window.screen.width > 950 && window.screen.width <= 1280){
            //         sessionStorage.setItem('istb','tablet')
            //         console.log('else if')
            //         // if(sessionStorage.getItem('istb') != null && window.screen.height > window.screen.width){
            //         //     console.log('portail')
            //         // }else{
            //         // // const userAgent = navigator.userAgent.toLowerCase();
            //         // // const isTablet = /(iphone|ipad|tablet|(android(?!.*mobile)))/.test(userAgent);
            //         // // console.log('isTablet : ',isTablet)
            //         // console.log('else if tablet')
                    
            //         // this.isMobile = true
            //         // // this.isMobile = window.screen.width < 1080
            //         // }
            //     }else{
            //         console.log('else --- pc')
            //         this.isMobile = false
    
            //         // this.isMobile = window.screen.availWidth 
            //         sessionStorage.setItem('ispc','pc')
            //     }
            //     console.log('ss -',sessionStorage.getItem('ismb'))
            //     console.log('ss -',sessionStorage.getItem('istb'))
            //     console.log('ss -',sessionStorage.getItem('ispc'))
            //    if((sessionStorage.getItem('ismb') != null && sessionStorage.getItem('istb') == null && sessionStorage.getItem('ispc') == null) || (sessionStorage.getItem('ismb') == null && sessionStorage.getItem('istb') != null && sessionStorage.getItem('ispc') == null) || (sessionStorage.getItem('ismb') == null && sessionStorage.getItem('istb') == null && sessionStorage.getItem('ispc') != null) ){
            //     console.log('your device is approve to use')
            //    }else{
            //     console.log('something wrong')
            //     // location.reload();
            
            //    }

            // ----------------------------------------------------------------------
           
        },
        getNow: function() {
            const today = new Date()
            const time =
                today.getHours() +
                ":" +
                (today.getMinutes() < 10 ? "0" : "") +
                today.getMinutes() +
                ":" +
                (today.getSeconds() < 10 ? "0" : "") +
                today.getSeconds()
            const dateTime = time
            this.timestamp = dateTime
        },
        async get_lan_lng() {
            // if (this.isMobile == false) {
            //     this.staff.device = "pc"
            // } else {
            //     this.staff.device = "mobile"
            // }
            this.checkaddr()
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    // console.log("this.gps")
                    this.gps.lat = position.coords.latitude
                    this.gps.lng = position.coords.longitude
                },
                (error) => {
                    //   console.log(error.message, "-- message ");
                    this.$swal({
                        title: "Alert",
                        text:
                            "กรุณาตั้งค่าเปิดให้เข้าถึง Location และ Refresh ระบบใหม่อีกครั้ง",
                        icon: "warning",
                        button: false,
                        closeOnClickOutside: false,
                    })
                }
            )
            const url = `${process.env.VUE_APP_ROOT_API}/api/getbranch`
            try {
                const { data } = await axios.get(`${url}`)
                this.branch_new = data
                // console.log("branch_new")
            } catch (error) {
                console.log(error)
            }
        },
        async checkaddr() {
            // console.log("--xxx")
            // var gps = {
            //     lat: this.gps.lat.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0],
            //     lng: this.gps.lng.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0],
            // }
            const url = `${process.env.VUE_APP_ROOT_API}/api/check-location`
            try {
                const { data } = await axios.post(`${url}`, this.gps)
                const ip = await axios.get(`https://api.ipify.org?format=json`)
                // console.log(ip.data.ip)
                this.staff.ip = ip.data.ip
                this.branch = data
            } catch (error) {
                console.log(error)
            }
        },
        async onCapture() {
            // this.img = await this.$refs.webcam.capture();
            await this.stamptime()
        },
        async checkstaff(params) {
            let chk = params[0] + params[1]

            // เอาไว้ก่อนอย่าพึ่งลบ
            // console.log(params, params.length, "-params")
            let chk_p
            if (this.staff.emp_id == "qq") {
                chk_p = true
                this.staff.emp_id = "P19-063"
            }
            // console.log(chk_p)

            if (params.length == 3 && chk != "HM" && chk != "T0") {
                this.staff.emp_id = this.staff.emp_id + "-"
            }
            if (
                params.length == 7 ||
                (chk == "HM" && params.length == 5) ||
                (chk == "T0" && params.length == 4) ||
                chk_p == true
            ) {
                // console.log(this.staff, "this.staff")
                const url = `${process.env.VUE_APP_ROOT_API}/api/check-staff-att`
                try {
                    const { data, status } = await axios.post(
                        `${url}`,
                        this.staff
                    )

                    console.log(data)
                    if (data.status == "unknown") {
                        this.show = true
                        this.show2 = false
                        swal({
                            title: "Warning !",
                            text:
                                "คุณอยู่นอกพื้นที่ ยืนยันการลงเวลาทำงานหรือไม่ ?",
                            icon: "warning",
                            button: true,
                        })
                        this.data = data
                    } else if (data.status == "ok") {
                        // console.log(data)
                        this.data = data
                        this.show = false
                        this.show2 = true
                    } else if (data.status == "error") {
                        this.show = true
                        this.show2 = false
                        swal({
                            title: "Fail !",
                            text: data.remark,
                            icon: "error",
                            timer: 2000,
                            button: false,
                        })
                    }
                } catch (error) {
                    console.log(error)
                }
            } else {
                this.data = []
            }
        },
        async stamptime() {
            const context = this.$refs.canvas.getContext("2d")
            if (this.isMobile == false) {
                context.drawImage(this.$refs.camerapc, 0, 0, 450, 337.5)
            } else {
                context.drawImage(this.$refs.cameramoblie, 0, 0, 450, 337.5)
            }
            this.staff.img = document
                .getElementById("photoTaken")
                .toDataURL("image/jpeg")
            let devicex
            if (this.isMobile == false) {
                devicex = "pc"
            } else {
                devicex = "mobile"
            }
            this.staff.lat = this.gps.lat
            this.staff.lng = this.gps.lng
            // this.staff.remark = this.data.remark
            // this.staff.device = this.device
            this.staff.device = devicex
            this.staff.branch_id = this.distance_used.branch_id
            this.staff.km = this.distance_used.km
            // console.log(this.staff)
            // this.staff.img = this.img;

            const url = `${process.env.VUE_APP_ROOT_API}/api/save-att`
            try {
                const { data, status } = await axios.post(`${url}`, this.staff)
                if (status == 200 && data.status != "error") {
                    var imgshow = `${process.env.VUE_APP_ROOT_API}/api/time-att/image/${data.img}`
                    this.$swal({
                        title: "ลงเวลาเรียบร้อย !",
                        text: data.date + "  " + data.time,
                        icon: imgshow,
                        timer: 2000,
                        buttons: false,
                    }).then(() => {
                        this.$root.$router.push({
                            path: "/Timeatt",
                        })
                        this.show = true
                        this.show2 = false
                        this.staff = {
                            emp_id: "",
                            remark: "",
                            img: "",
                            lat: "",
                            lng: "",
                            ip: "",
                            device: "",
                            branch_id: "",
                            km: "",
                        }
                        this.data = []
                        // this.createCameraElement();
                    })
                }
            } catch (error) {
                console.log(error)
            }
        },

        createCameraElement() {
            const constraints = (window.constraints = {
                audio: false,
                video: true,
            })

            navigator.mediaDevices
                .getUserMedia(constraints)
                .then((stream) => {
                    // console.log(this.device)

                    // if (this.device == "pc") {
                    //     this.$refs.camerapc.srcObject = stream
                    // } else {
                    //     this.$refs.cameramoblie.srcObject = stream
                    // }

                    if (this.isMobile == false) {
                        this.$refs.camerapc.srcObject = stream
                    } else {
                        this.$refs.cameramoblie.srcObject = stream
                    }
                })
                .catch((error) => {})
        },
        distance(lat1, lon1, lat2, lon2, unit) {
            if (lat1 == lat2 && lon1 == lon2) {
                return 0
            } else {
                var radlat1 = (Math.PI * lat1) / 180
                var radlat2 = (Math.PI * lat2) / 180
                var theta = lon1 - lon2
                var radtheta = (Math.PI * theta) / 180
                var dist =
                    Math.sin(radlat1) * Math.sin(radlat2) +
                    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
                if (dist > 1) {
                    dist = 1
                }
                dist = Math.acos(dist)
                dist = (dist * 180) / Math.PI
                dist = dist * 60 * 1.1515
                if (unit == "K") {
                    dist = dist * 1.609344
                }
                if (unit == "N") {
                    dist = dist * 0.8684
                }

                return dist
            }
        },
        caldistance() {
            // console.log("caldistance")
            this.branch_new.map((each) => {
                var radlat1 = (Math.PI * this.gps.lat) / 180
                var radlat2 = (Math.PI * each.branch_lat) / 180
                var theta = this.gps.lng - each.branch_lng
                var radtheta = (Math.PI * theta) / 180
                var dist =
                    Math.sin(radlat1) * Math.sin(radlat2) +
                    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
                if (dist > 1) {
                    dist = 1
                }
                dist = Math.acos(dist)
                dist = (dist * 180) / Math.PI
                dist = dist * 60 * 1.1515
                dist = dist * 1.609344
                this.distance_cal.push({
                    km: Number(
                        dist.toString().match(/^-?\d+(?:\.\d{0,1})?/)[0]
                    ),
                    branch_name: each.branch_name,
                    branch_id: each.branch_id,
                })
            })
        },
        chk_active_camera() {
            // console.log(this.$refs.camerapc, "-test active")
            // let video
            // if (this.isMobile == false) {
            let video = this.$refs.camerapc
            // } else {
            // let video = this.$refs.cameramoblie
            // }

            // console.log(video)

            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices
                    .getUserMedia({ video: true })
                    .then(function(stream) {
                        video.srcObject = stream
                        video.play()
                    })
                    .catch((error) => {
                        this.$swal({
                            title: "Alert",
                            text:
                                "กรุณาตั้งค่าเปิดให้เข้าถึงกล้อง หรือ เปลี่ยนไปใช้เครื่องที่มีกล้อง และ Refresh ระบบใหม่อีกครั้ง",
                            icon: "warning",
                            button: false,
                            closeOnClickOutside: false,
                        })
                    })
            }
        },

        // --------------------------------------------------------------------------------------------------------- new method //namo28
        setsize(){ //check x,y of screen 
            
            this.size_screen.x = window.screen.width
            this.size_screen.y = window.screen.height
            // console.log('y',this.size_screen.y)
            console.log('device',this.device)
            console.log('staff',this.staff.device)
if(this.size_screen.x > this.size_screen.y & this.device == "mobile"){
    // console.log("landscape display")

}
            // console.log("x = ",this.size_screen.x+", y = "+this.size_screen.y)
            // console.log("device ", this.device)
            // console.log("staff device ", this.staff.device)
        },
    },
    watch: {
        branch_new: function(newQuestion, oldQuestion) {
            if (this.gps.lat != "") {
                this.caldistance()
            }
        },
        "gps.lat": function(newQuestion, oldQuestion) {
            if (this.branch_new.length != 0) {
                this.caldistance()
            }
        },
        distance_cal: function(newQuestion, oldQuestion) {
            this.distance_used = this.distance_cal.reduce(function(prev, curr) {
                return prev["km"] < curr["km"] ? prev : curr
            })
            // console.log(this.distance_used.km)
            // if (this.distance_used.km > 0.5) {
            //     this.distance_used = {
            //         km: "000",
            //         branch_id: "Unknown",
            //         branch_name: "Unknown",
            //     }
            // }
            this.staff.branch_id = this.distance_used.branch_id
            // console.log(this.distance_used, "- TEST LOG , Page Time Att")
        },
    },
    computed: {
        checkpermission() {
            return true
        },
        
    },
}
</script>
<style scoped>
.mar-t-x {
    margin-top: -60px !important;
    margin-bottom: 20px;
}
.swal-icon:first-child {
    width: 300px !important;
}
.v-input .v-label {
    font-size: 3em;
}
.bodyx {
    background: #0f3854;
    background: radial-gradient(ellipse at center, #0067bb 0%, #ffffff 70%);
    background-size: 100%;
    height: 100%;
}

.timex {
    font-family: "Share Tech Mono", monospace;
    color: #034257 !important;
    text-shadow: 0 0 20px rgba(10, 175, 230, 1), 0 0 20px rgba(10, 175, 230, 0) !important;
    text-align: center;
    /* position: absolute; */
    /* left: 50%;
    top: 50%; */
    /* transform: translate(-50%, -50%); */
    letter-spacing: 0.05em;
    font-size: 60px;
    padding: 5px 0;
}
#clock.date {
    letter-spacing: 0.1em;
    font-size: 24px;
}
.text-x1 {
    font-family: "Share Tech Mono", monospace;
    letter-spacing: 0.1em;
    font-size: 26px;
    /* padding: 20px 0 0; */
    color: #034257 !important;
    text-shadow: 0 0 20px rgba(10, 175, 230, 1), 0 0 20px rgba(10, 175, 230, 0) !important;
}
.text-x11 {
    font-family: "Share Tech Mono", monospace;
    /* letter-spacing: 0.1em; */
    font-size: 24px;
    /* padding: 20px 0 0; */
    color: #012d3b !important;
    text-shadow: 0 0 20px rgba(10, 175, 230, 1), 0 0 20px rgba(10, 175, 230, 0) !important;
}
.text-x11x {
    font-family: "Share Tech Mono", monospace;
    /* letter-spacing: 0.1em; */
    font-size: 24px;
    /* padding: 20px 0 0; */
    color: #204552 !important;
    text-shadow: 0 0 20px rgba(10, 175, 230, 1), 0 0 20px rgba(10, 175, 230, 0) !important;
}
.text-x111 {
    font-family: "Share Tech Mono", monospace;
    font-size: 24px;
    color: #70cbe9 !important;
    text-shadow: 0 0 20px rgba(10, 175, 230, 1), 0 0 20px rgba(10, 175, 230, 0) !important;
}

.text-x1111 {
    font-family: "Share Tech Mono", monospace;
    font-size: 21px;
    color: #70cbe9 !important;
    text-shadow: 0 0 20px rgba(10, 175, 230, 1), 0 0 20px rgba(10, 175, 230, 0) !important;
}
.text-x2 {
    font-family: "Share Tech Mono", monospace;
    /* letter-spacing: 0.1em; */
    font-size: 14px !important;
    /* padding: 20px 0 0; */
    color: #02516b !important;
    text-shadow: 0 0 20px rgba(10, 175, 230, 1), 0 0 20px rgba(10, 175, 230, 0) !important;
}

.text-x3 {
    font-family: "Share Tech Mono", monospace;
    /* letter-spacing: 0.1em; */
    font-size: 12px !important;
    /* padding: 20px 0 0; */
    color: #3c6775 !important;
    /* text-shadow: 0 0 20px rgba(10, 175, 230, 1), 0 0 20px rgba(10, 175, 230, 0) !important; */
}

.text-x4 {
    /* font-family: "Share Tech Mono", monospace; */
    font-size: 14px !important;
    color: #ff0000 !important;
    text-shadow: 0 0 20px rgb(233, 151, 97), 0 0 20px rgba(230, 135, 10, 0) !important;
}
.text-x44 {
    /* font-family: "Share Tech Mono", monospace; */
    font-weight: bold;
    font-size: 16px !important;
    color: #ff0000 !important;
    text-shadow: 0 0 20px rgb(233, 151, 97), 0 0 20px rgba(230, 135, 10, 0) !important;
}
</style>
